import { createAction } from '@reduxjs/toolkit'

export updateTreeData = createAction('homeTree/treeDataUpdated')
export updateNodeData = createAction('homeTree/nodeDataUpdated')
export setTreeData = createAction('homeTree/treeDataSet')
export setNodeData = createAction('homeTree/nodeDataSet')
export setRoots = createAction('homeTree/rootsSet')
export setExpandedKeys = createAction('homeTree/expandedKeysSet')
export deleteAction = createAction('homeTree/actionDeleted')
export deleteMacro = createAction('homeTree/macroDeleted')
export deleteView = createAction('homeTree/viewDeleted')
